import * as angular from 'angular';
import * as _ from "lodash";
import DefectCausesServiceName, {DefectCausesService} from "../../services/defectCauses/defectCause.service";
import DefectActivity from "../../models/activity/defectActivity";
import template from './defectCauses.tpl.html';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";

let requires = [DefectCausesServiceName];

export default angular.module('aps.controller.defectCauses', requires)
  .controller('DefectCausesCtrl', defectCausesCtrl)
  .name;

export interface DefectCausesData {
  defect: DefectActivity;
}

interface DefectCausesServiceController {
  kickoffCourseOfAction(defectCause: apsViewModels.DefectCauseSelection): void;
  cancel(): void;
  defect: DefectActivity;
  defectCauses: apsViewModels.DefectCauseSelection[];
}

export function openDefectCauses(data: DefectCausesData,
                                 $modal: mm.foundation.modal): angular.IPromise<apsViewModels.DefectCauseSelection> {
  return $modal.open({
    template: template,
    controller: 'DefectCausesCtrl as defectCausesCtrl',
    resolve: {
      data: () => data
    }
  }).result;
}

function defectCausesCtrl($modalInstance: mm.foundation.modalInstance,
                          data: DefectCausesData,
                          defectCausesService: DefectCausesService): DefectCausesServiceController {

  'use strict';
  let vm = this as DefectCausesServiceController;
  vm.defect = data.defect;

  let defectTypeId = vm.defect.defectTypeId;
  defectCausesService.getDefectCauseSelections(defectTypeId).then((defectCauses) => {
    vm.defectCauses = _.filter(defectCauses, x => x.enabled === true);
    if (vm.defectCauses.length === 0) {
      $modalInstance.close();
    }
  });

  vm.kickoffCourseOfAction = function(defectCause) {
    $modalInstance.close(defectCause);
  };

  vm.cancel = function() {
    $modalInstance.close();
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/defectCauses/defectCauses.controller.ts